










import Vue from 'vue'
import User from '@/types/User.interface'
import VerificationForm from '@/components/VerificationForm.vue'
import mixin from '@/mixins/tenant-nav-mixin'
export default Vue.extend({
    components: { VerificationForm },
    mixins: [mixin],
    data() {
        return {
            //Flag that determines if we've already resent a phone verification code
            sentPhoneOnce: false,
            // Flag that determines if a user is being verified
            processing: false,
            quoteLine1:
                'Businesses rely on text messaging for instant delivery. Soon, you’ll do the same!',
            // The error message that appears on the the verification input
            errorMessage: null
        }
    },
    async mounted() {
        //  Send a verification code to the user's phone
        this.$store.dispatch('authVerifyPhoneSend')
    },
    computed: {
        query(): string | null {
            //  If query params exist, return string format
            if (this.$route.query) return '?' + window.toUrlParams(this.$route.query)

            //  Else, return nothing
            return null
        },
        user(): User {
            return this.$store.getters.user
        }
    },
    methods: {
        changePhone(): void {
            // Display edit form
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Change Phone Number',
                icon: 'mdi-pencil',
                color: 'primary',
                closeable: true,
                component: 'app-form',
                callback: (user) => this.userUpdate(user),
                props: {
                    model: this.user,
                    inputs: [
                        {
                            type: 'PHONE',
                            name: 'Phone',
                            label: 'Phone',
                            path: 'mobilephone',
                            validate: 'phone'
                        }
                    ]
                }
            })
        },
        confirmPhoneResend(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Send a new Code?',
                text: `Do you want to send a new verification code to <b>${this.user.mobilephone}</b>?`,
                icon: 'mdi-alert',
                color: 'yellow darken-2',
                callback: (result: boolean) => this.phoneResend(result)
            })
        },
        onResendPhoneVerification(): void {
            return this.sentPhoneOnce ? this.confirmPhoneResend() : this.phoneResend(true)
        },
        async onSubmit(code: string): Promise<void> {
            // Indicate that wr are processing verification
            this.processing = true

            // Reset the error message
            this.errorMessage = null

            //  Create our payload
            const payload = { code: code }

            //  Send the verification request
            const response = await this.$store.dispatch('authVerifyPhone', payload)

            //  If the verification was successful, route to payment registration
            if (!response.isVerified) {
                this.errorMessage = "Oops! That's the wrong code. Please try again"
                this.processing = false
                return
            }

            //  Check if this user is already registered
            const registered = this.user.memberships?.length

            //  Check if there is a tenant id attached
            const tenant_id = this.$route.query.tenant_id

            //  If registered AND there is a tenant_id, navigate to tenant_id
            if (registered && tenant_id) this.goToTenant(tenant_id)
            //  Else we route the login
            else if (registered) this.routeLogin(this.user)
            //  Else, navigate to the payment step
            // else this.$router.push(`/register/icp${this.query || ''}`)
            else this.$router.push(`/register/payment`)
        },
        async phoneResend(dialog_result: boolean): Promise<void> {
            //  If the request is not confirmed, do nothing
            if (!dialog_result) return
            //  Send a verification code to the authenticated user's phone
            const sent = await this.$store.dispatch('authVerifyPhoneSend')

            //  If the verification code was NOT sent, do nothing
            if (!sent) return

            //  Else, notify the user of successfully sent verification code to their phone
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Verification Code Sent',
                text: `A new verification code has been sent to ${this.user.mobilephone}.`,
                icon: 'mdi-check-circle',
                color: 'primary'
            })

            //  Remember the user has resent a code at least once, this tiggers a confirm on the second send
            this.sentPhoneOnce = true
        },
        async userUpdate(user: User): Promise<void> {
            // Update the user
            user = await this.$store.dispatch('authUserPut', user)

            // Close the dialog
            this.$store.dispatch('dialogClose', 'APP')

            //  If the request failed, do nothing
            if (!user) return

            // After changing the auth user's phone, resend their invitation
            this.phoneResend(true)
        }
    }
})
